import type { Platform } from './types';

// Реестр — на globalThis, а не в переменной модуля: vi.resetModules() в
// тестах (и повторная загрузка модуля бандлером) создаёт новый экземпляр
// этого файла, и модульная переменная оказалась бы пустой у части импортёров.
const KEY: unique symbol = Symbol.for('vycord.platform');

const registry = globalThis as typeof globalThis & { [KEY]?: Platform };

export function configurePlatform(platform: Platform): void {
  registry[KEY] = platform;
}

export function getPlatform(): Platform {
  const platform = registry[KEY];
  if (!platform) {
    throw new Error(
      'shared: платформа не настроена — configurePlatform() должен выполниться до импорта сторов и сервисов',
    );
  }
  return platform;
}

export function resetPlatformForTests(): void {
  delete registry[KEY];
}
